import { AuthProvider, WelcomeExperiencePage as AuthWelcomeExperiencePage } from '@hub-la/fe-auth'

export const WelcomeExperienceInit = () => {
  return (
    <AuthProvider>
      <AuthWelcomeExperiencePage />
    </AuthProvider>
  )
}
